import { IArtistService } from '../../../shared/services/artistService/artistService';

export type ISocialService = ReturnType<typeof socialServiceFactory>;

/* @ngInject */
export function socialServiceFactory(
  $translate,
  wixSdk,
  artistService: IArtistService,
) {
  const urls = {
    facebook: '',
    twitter: '',
    track: '',
  };

  return {
    urls,
    updateArtistName,
  };

  function updateArtistName(name) {
    artistService.getArtist(name).then((data) => {
      const url = new URL(data.url);
      url.searchParams.append('trigger', 'track');
      urls.track = url.toString();
    });

    wixSdk.getSiteInfo(({ url }) => {
      $translate(['twitter-share-text', 'twitter-share-text-artist'], {
        name,
      }).then((translated) => {
        const twitterText = name
          ? translated['twitter-share-text-artist']
          : translated['twitter-share-text'];

        urls.facebook = encodeURI(
          `https://www.facebook.com/sharer/sharer.php?u=${url}`,
        );
        urls.twitter = encodeURI(
          `https://twitter.com/intent/tweet?text=${twitterText} ${url}`,
        );
      });
    });
  }
}
